import {
  ConfirmationDialog,
  ConfirmationDialogProps,
  ConfirmationDialogResult,
  makeDialog,
} from '@cast/design-system';

/**
 * Confirmation dialog for suppressing restrictions. Unlike the standard
 * `useConfirmationDialog`, it also closes when clicking the overlay.
 */
export const useSuppressConfirmationDialog = makeDialog<
  ConfirmationDialogProps,
  ConfirmationDialogResult
>(ConfirmationDialog, { closeOnOverlayClick: true });
